import { PropsWithChildren } from 'react';

function App({ children }: PropsWithChildren) {
  return <div>{children}</div>;
}

export default App;
